module.exports = __webpack_public_path__ + "img/hc.21704981.jpg";